<mat-card>
    <mat-card-header>
        <mat-card-title style="text-align:center;">O Usuário atual não tem permissão para acessar essa rota
            <mat-icon color="warn">warning</mat-icon>
        </mat-card-title>
    </mat-card-header>
</mat-card>
